var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid d-flex flex-column flex-fill h-100 p-t-30",
    },
    [
      _c("ak-export", {
        attrs: { bundle: _vm.exportBundle, definition: _vm.exportDefinition },
        on: {
          downloaded: function ($event) {
            return _vm.$emit("downloaded")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function (ref) {
              var db = ref.db
              var isInitializing = ref.isInitializing
              return [
                _c("h2", [
                  _vm._v("Export"),
                  !isInitializing
                    ? _c("span", [_vm._v(": " + _vm._s(db.title))])
                    : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }